import { createApp } from "vue";
import i18n from "./common/helpers/i18n";
import router from "./router";
import { createPinia } from "pinia";
import Passport, {
  getUserPermissions,
  getUserRoles,
  getUserScopes,
} from "@/common/plugins/passport";
import profileWatcher from "@/common/plugins/profileWatcher";
import App from "./App.vue";
import Alert from "@/common/plugins/alert";
import EventBus from "@/common/plugins/eventBus";
import Posthog from "@/common/plugins/posthog";
import Logger from "@/common/plugins/Logger";
import { updateTokenAndProfilreFromLocalStore } from "@/modules/auth/store";

// styles
import "./styles/styles.css";

const pinia = createPinia();
const app = createApp(App);

pinia.use(updateTokenAndProfilreFromLocalStore);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(profileWatcher);
app.use(Passport, { getUserPermissions, getUserRoles, getUserScopes });
app.use(Alert);
app.use(EventBus);
app.use(Logger);

if (import.meta.env.VITE_APP_TRACKING_ENV === "production") {
  app.use(Posthog);
}

app.mount("#app");

app.config.errorHandler = (err, vm, info) => {
  console.error("Globlal vue file error captured:", err, info);
};
